import { render, staticRenderFns } from "./ApplicantInfo.vue?vue&type=template&id=ffee83d4"
import script from "./ApplicantInfo.vue?vue&type=script&lang=ts"
export * from "./ApplicantInfo.vue?vue&type=script&lang=ts"
import style0 from "./ApplicantInfo.vue?vue&type=style&index=0&id=ffee83d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports